// code copied from Shopify Dawn theme assets/recipient-form.js, then set up for export
import refs from '../helpers/refs'

class CGiftCardRecipientForm {
  constructor (el) {
    this.form = el
    // making this conditional because the form won't be on all product pages but there is no way to conditionally import a module
    // testing for the presence of the form - if it's not there nothing else will work
    if (this.form) {
      this.init()
    }
  }

  init () {
    this.$root = this.form
    this.$refs = refs(this.$root)

    this.recipientFieldsLiveRegion = this.$root.querySelector(`#Recipient-fields-live-region-${this.$root.dataset.sectionId}`)
    this.checkboxInput = this.$root.querySelector(`#Recipient-checkbox-${this.$root.dataset.sectionId}`)
    this.checkboxInput.disabled = false
    this.hiddenControlField = this.$root.querySelector(`#Recipient-control-${this.$root.dataset.sectionId}`)
    this.hiddenControlField.disabled = true
    this.emailInput = this.$root.querySelector(`#Recipient-email-${this.$root.dataset.sectionId}`)
    this.nameInput = this.$root.querySelector(`#Recipient-name-${this.$root.dataset.sectionId}`)
    this.messageInput = this.$root.querySelector(`#Recipient-message-${this.$root.dataset.sectionId}`)
    this.sendonInput = this.$root.querySelector(`#Recipient-send-on-${this.$root.dataset.sectionId}`)
    this.offsetProperty = this.$root.querySelector(`#Recipient-timezone-offset-${this.$root.dataset.sectionId}`)
    if (this.offsetProperty) {
      this.offsetProperty.value = new Date().getTimezoneOffset().toString()
    }

    this.errorMessageWrapper = this.$root.querySelector('.product-form__recipient-error-message-wrapper')
    this.errorMessageList = this.errorMessageWrapper ? this.$root.querySelector('ul') : null
    this.errorMessage = this.errorMessageWrapper ? this.$root.querySelector('.error-message') : null
    this.defaultErrorHeader = this.errorMessage ? this.$root.innerText : null

    this.currentProductVariantId = this.$root.dataset.productVariantId
    this.$root.addEventListener('change', this.onChange.bind(this))
    this.onChange()
  }

  onChange () {
    if (this.checkboxInput.checked) {
      this.enableInputFields()
      this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded
    } else {
      this.clearInputFields()
      this.disableInputFields()
      this.clearErrorMessage()
      this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed
    }
  }

  inputFields () {
    return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput]
  }

  disableableFields () {
    return [...this.inputFields(), this.offsetProperty]
  }

  clearInputFields () {
    this.inputFields().forEach((field) => { field.value = '' })
  }

  enableInputFields () {
    this.disableableFields().forEach((field) => {
      field.disabled = false
      if (field.closest('.recipient-fields__field')) {
        field.closest('.recipient-fields__field').classList.remove('hidden')
      }
    })
  }

  disableInputFields () {
    this.disableableFields().forEach((field) => {
      field.disabled = true
      if (field.closest('.recipient-fields__field')) {
        field.closest('.recipient-fields__field').classList.add('hidden')
      }
    })
  }

  displayErrorMessage (title, body) {
    this.clearErrorMessage()
    this.errorMessageWrapper.hidden = false
    if (typeof body === 'object') {
      this.errorMessage.innerText = this.defaultErrorHeader
      return Object.entries(body).forEach(([key, value]) => {
        const errorMessageId = `RecipientForm-${key}-error-${this.$root.dataset.sectionId}`
        const fieldSelector = `#Recipient-${key}-${this.$root.dataset.sectionId}`
        // const message = `${value.join(', ')}`
        const errorMessageElement = this.$root.querySelector(`#${errorMessageId}`)
        const errorTextElement = errorMessageElement ? errorMessageElement.querySelector('.error-message') : null

        if (this.errorMessageList) {
          this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, value))
        }

        errorTextElement.innerText = `${value}.`
        errorMessageElement.classList.remove('hidden')

        const inputElement = this[`${key}Input`]
        if (!inputElement) { return }

        inputElement.setAttribute('aria-invalid', true)
        inputElement.setAttribute('aria-describedby', errorMessageId)
        // to use DS built-in error fields find ref="errorText" for the field, but their system uses very unhelpful feedback so avoiding it here
      })
    }

    this.errorMessage.innerText = body
  }

  createErrorListItem (target, message) {
    const li = document.createElement('li')
    const a = document.createElement('a')
    a.setAttribute('href', target)
    a.innerText = message
    li.appendChild(a)
    li.className = 'error-message'
    return li
  }

  clearErrorMessage () {
    this.errorMessageWrapper.hidden = true

    if (this.errorMessageList) { this.errorMessageList.innerHTML = '' }

    this.$root.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
      field.classList.add('hidden')
      const textField = field.querySelector('.error-message')
      if (textField) { textField.innerText = '' }
    })

    /* not allowed by linter
    [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
      inputElement.setAttribute('aria-invalid', false)
      inputElement.removeAttribute('aria-describedby')
    })
    */
    // replacing with this un-DRY code
    this.emailInput.setAttribute('aria-invalid', false)
    this.emailInput.removeAttribute('aria-describedby')
    this.messageInput.setAttribute('aria-invalid', false)
    this.messageInput.removeAttribute('aria-describedby')
    this.nameInput.setAttribute('aria-invalid', false)
    this.nameInput.removeAttribute('aria-describedby')
    this.sendonInput.setAttribute('aria-invalid', false)
    this.sendonInput.removeAttribute('aria-describedby')
  }

  resetRecipientForm () {
    if (this.checkboxInput.checked) {
      this.checkboxInput.checked = false
      this.clearInputFields()
      this.clearErrorMessage()
    }
  }
}

// original - leaving out because gets imported into and instantiated in c-product-info.js, which is the only place this form exists
// some dev in the future is going to hate me for doing this
/*
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-gift-card-recipient-form')
    .forEach(el => new CGiftCardRecipientForm(el))
})
*/

export default CGiftCardRecipientForm
